import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { graphql, compose } from "react-apollo";
import 'react-datepicker/dist/react-datepicker.css'

import {
	MutationUpdateAssessment,
	MutationCreateAssessment,
	QueryGetAssessment,
    QueryCheckMedicalNumber,
} from "../GraphQL/MutationAssessment";

import * as MESSAGES from '../Lib/Messages';
import BreadCrumb from './BreadCrumb';
import Spinner from './Spinner';
import Notification from './Notification';
import InputError from './InputError';
import Validator from '../Lib/Validator';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'

import { convertEmptyString } from '../Lib/Utils';
import moment from "moment";
import { v4 as uuid } from "uuid";
import { client } from '../App';

class PatientForm extends Component {
	subHandApps = localStorage.getItem('subHandsApps');
	constructor(props) {
		super(props);

		this.state = {
			medicalNumber: '',
			loading: false,
			isEdit: false,
			errors: {},
			isError: false,
			errorMessage: null
		};

		this.state = {...this.getInitialState(), ...this.state};
		this.handleChange = this.handleChange.bind(this);
		this.handNewAnalysis = this.handNewAnalysis.bind(this);
		this.clearForm = this.clearForm.bind(this);
	}

	static defaultProps = {
		getAssessment: () => null,
		createdAssessment: () => null,
		updateAssessment: () => null
	}

	getInitialState = () => ({
		assessment: {
			therapistId: this.subHandApps,
			assessmentId: null,
			createdBy: this.subHandApps,
			firstName: '',
			lastName: '',
			birthday: null,
			medicalNumber: '',
			searchField: '',
			created: moment.utc().format(),
			updated: moment.utc().format()
		}
	});

	handleChange(event) {
		let { target: { name, value } } = event;
		if(event.target.type === 'checkbox') {
			value = event.target.value;
		}

		const { assessment } = this.state;
		assessment[name] = value;
		this.setState({ assessment });
	}

	handleDateChange(field, value) {
		const { assessment } = this.state;
		assessment[field] = value.format('MM/DD/YYYY');
		this.setState({ assessment });
	}

	isValidation() {
		this.setState({errors: {}, errorMessage: ''});

		var errors = {};
		var isError = false;
		const { assessment } = this.state;
		var validator = new Validator();

		if(!validator.required(assessment.firstName)) {
			errors['firstName'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if(!validator.required(assessment.lastName)) {
			errors['lastName'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if(assessment.medicalNumber && !validator.alphanumeric(assessment.medicalNumber)) {
			errors['medicalNumber'] = MESSAGES.ERROR_ANPHANUMERIC;
			isError = true;
		}
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			isError = true;
		}

		if(isError) {
			this.setState({ errors });
			return false;
		}

		return true;
	}

	clearForm = () => {
		this.setState(this.getInitialState());
	}

	handNewAnalysis() {
		const { history } = this.props;
		const { assessment } = this.state;
		history.push('/assessments/create/' + assessment.assessmentId);
	}

	handleSave = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		this.setState({ loading: true });
		const { isEdit, assessment } = this.state;
		const { createAssessment, updateAssessment } = this.props;
		assessment['updated'] = moment.utc().format();

		if(assessment.medicalNumber !== this.state.medicalNumber) {
			const patient = await client.query({
				query: QueryCheckMedicalNumber,
				fetchPolicy: 'network-only',
				variables: {
				  therapistId: this.subHandApps,
				  medicalNumber: assessment.medicalNumber
				},
			});
			if(patient.data.checkMedicalNumber) {
				var patientItem = patient.data.checkMedicalNumber;
				if(patientItem.items.length > 0) {
					this.setState({ errorMessage: MESSAGES.ERROR_MEDICAL_NUMBER, isError: true, loading: false });
					return false;
				}
			}

		}

		assessment['searchField'] = assessment.firstName + ' ' + assessment.lastName + ' ' + assessment.medicalNumber;
		if(assessment.birthday) {
			assessment['searchField'] += ' ' + assessment.birthday;
			assessment['searchField'] += ' ' + moment(assessment.birthday, 'MM/DD/YYYY').format('DD MMMM YYYY');
		}
		assessment['searchField'] = assessment['searchField'].toLowerCase();
		if(isEdit) {
			try {
				const results = await updateAssessment(assessment);
				if(results.data) {
					this.setState({ errorMessage: MESSAGES.SUCCESS_UPDATE_PATIENT, isError: false });
				} else {
					this.setState({ errorMessage: MESSAGES.ERROR_UPDATE_PATIENT, isError: true });
				}
			} catch(e) {
				this.setState({ errorMessage: MESSAGES.ERROR_UPDATE_PATIENT, isError: true });
			}
		} else {
			assessment['assessmentId'] = uuid();
			assessment['created'] = moment.utc().format();
			try {
				const results = await createAssessment(assessment);
				if(results.data.createAssessment) {
					this.setState({ errorMessage: MESSAGES.SUCCESS_CREATE_PATIENT, isError: false });
					var assessmentId = results.data.createAssessment.assessmentId;
					assessment['assessmentId'] = assessmentId;
					this.setState({ assessment });
					this.setState({ medicalNumber: assessment.medicalNumber, isEdit: true });
					this.props.history.push('/patients/' + assessmentId);
				} else {
					this.setState({ errorMessage: MESSAGES.ERROR_CREATE_PATIENT, isError: true });
				}
			} catch(e) {
				this.setState({ errorMessage: MESSAGES.ERROR_CREATE_PATIENT, isError: true });
			}
		}
		this.setState({ loading: false });
	}

	componentWillReceiveProps(newProps) {
		if (newProps !== this.props) {
		}
	}

	loadData = async (e) => {
		this.setState({ loading: true });
		const { history, match: { params } } = this.props;
		if(params.id) {
			const { assessment } = this.state;
			this.state.isEdit = true;
			const result = await client.query({
				query: QueryGetAssessment,
				fetchPolicy: 'network-only',
				variables: {
				  therapistId: this.subHandApps,
				  assessmentId: params.id
				},
			});

			var data = result.data.getAssessment;
			if(data) {
				assessment['assessmentId'] = data.assessmentId;
				assessment['firstName'] = data.firstName;
				assessment['lastName'] = data.lastName;
				assessment['created'] = data.created;
				assessment['updated'] = data.updated;
				if(data.birthday) {
					assessment['birthday'] = data.birthday;
				}
				if(data.medicalNumber) {
					assessment['medicalNumber'] = data.medicalNumber;
					this.setState({ medicalNumber: data.medicalNumber });
				}

				this.setState({ assessment });
				this.setState({ loading: false });
			} else {
				history.push('/patients/list');
			}
		}

		this.setState({ loading: false });
	}

	componentDidMount() {
		this.clearForm();
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
		}
		this.loadData();
	}

	render() {
		const { isEdit, loading, assessment, isError, errors, errorMessage } = this.state;
		return (
			<section role="main" className="content-body">
				<header className="page-header">
					<h2>Patients</h2>
					<BreadCrumb title1="Patients" title2={ isEdit ? 'Edit' : 'Create' } />
				</header>

				<Notification isError={isError} message={errorMessage} />

				<div className="row">
					<div className="col">
						<section className="card">
							<div className={`card-body${loading ? ' loading-overlay-showing' : ''}`}>
		                        <Spinner />
								<form className="form-horizontal form-bordered" method="POST">
									<div className={`form-group row ${errors.firstName ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">First Name*</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-address-book"></i>
												</span>
												<input type="text" name="firstName" className="form-control" value={assessment.firstName} onChange={this.handleChange} />
											</div>
											<InputError error={errors.firstName} />
										</div>
									</div>

									<div className={`form-group row ${errors.lastName ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">Last Name*</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-address-book"></i>
												</span>
												<input type="text" name="lastName" className="form-control" value={assessment.lastName} onChange={this.handleChange} />
											</div>
											<InputError error={errors.lastName} />
										</div>
									</div>

									<div className="form-group row">
										<label className="col-lg-3 control-label text-lg-right pt-2">Birthday</label>
										<div className="col-lg-6">
											<div className="input-group input-date">
												<span className="input-group-addon">
													<i className="fa fa-calendar-alt"></i>
												</span>
												<DatePicker
													className="form-control"
													id="birthday"
													selected={(assessment.birthday) ? moment(assessment.birthday, 'MM/DD/YYYY') : null}
													onChange={this.handleDateChange.bind(this, 'birthday')}
													showMonthDropdown
													showYearDropdown
													dropdownMode="select"
													dateFormat="MM/DD/YYYY"
												/>
											</div>
										</div>
									</div>

									<div className={`form-group row ${errors.medicalNumber ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">Medical Record ID</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-id-card"></i>
												</span>
												<input type="text" name="medicalNumber" className="form-control" value={assessment.medicalNumber || ''} onChange={this.handleChange} />
											</div>
											<InputError error={errors.medicalNumber} />
										</div>
									</div>

								</form>
							</div>

							<footer className="card-footer">
								<div className="row justify-content-end">
									<div className="col-sm-9">
										<button type="submit" className="btn btn-primary" onClick={this.handleSave}>{isEdit ? 'Save' : 'Create'}</button>
										<Link to="/patients/list" className="btn btn-default">Cancel</Link>
										{(isEdit) ? (<button type="button" className="btn btn-success" onClick={this.handNewAnalysis}>Start New Asssessment</button>):
										(<button type="reset" className="btn btn-default" onClick={this.clearForm}>Reset</button>)}
									</div>
								</div>
							</footer>
						</section>
					</div>
				</div>
			</section>
		)
	}
}

export default compose(
	graphql(MutationCreateAssessment, {
		props: (props) => ({
			createAssessment: (assessment) => {
				return props.mutate({
					variables: convertEmptyString(assessment),
					optimisticResponse: () => ({
                        createAssessment: {
                            ...assessment, __typename: 'Assessment'
                        }
                    }),
					// update: (proxy, { data: { createAssessment } }) => {
					// 	console.log("createAssessment", createAssessment);
					// }
				})
			}
		})
	}),
	graphql(MutationUpdateAssessment, {
		props: (props) => ({
			updateAssessment: (assessment) => {
				return props.mutate({
					variables: convertEmptyString(assessment),
					optimisticResponse: {
						updateAssessment: {
							...assessment, __typename: 'Assessment',
						}
					}
				})
			}
		})
	}),
)(PatientForm);
